'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateChatWidgetHeight = calculateChatWidgetHeight;

var _dimensions = require('../constants/dimensions');

var _calculatePixelsToShrinkBy = require('./calculatePixelsToShrinkBy');

function calculateChatWidgetHeight(windowHeight, _ref) {
  var showCloseButton = _ref.showCloseButton;

  return _dimensions.BASE_WIDGET_HEIGHT - (0, _calculatePixelsToShrinkBy.calculatePixelsToShrinkBy)(windowHeight, { showCloseButton: showCloseButton });
}